// extracted by mini-css-extract-plugin
export default {"resultWrap":"style_resultWrap__+3dxM","resultDescription":"style_resultDescription__a0tFF","support":"style_support__en3lX"};